<template>
  <div class="achievement-topBar">
    <div class="btn-list">
      <el-button @click="back" size="small">返回</el-button>
      <el-button v-hasPermi="'sc:classscore:comparison'" type="primary" size="small"
        @click="classComparison">班级成绩对比</el-button>
      <el-button v-hasPermi="'sc:classscore:comparison'" type="primary" size="small"
        @click="externalPerformanceComparison">校外成绩对比</el-button>
      <el-button v-hasPermi="'sc:classscore:comparison'" type="primary" size="small"
        @click="classDimension">班级维度对比</el-button>
      <el-button type="success" size="small" @click="deriveClassGrades"
        v-hasPermi="'sc:classrank:export'">导出班级排名</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  methods: {
    back() {
      this.$emit("back");
    },
    // 导出
    deriveClassGrades() {
      this.$emit("deriveClassGrades");
    },
    // 班级成绩对比
    classComparison() {
      this.$emit("classComparison", "classComparison");
    },
    // 校外成绩对比
    externalPerformanceComparison() {
      this.$emit(
        "externalPerformanceComparison",
        "externalPerformanceComparison"
      );
    },
    // 班级维度对比
    classDimension() {
      this.$emit("classDimension", "classDimension");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementTopBar.scss";
</style>